import { CustomButton } from "ui";
import FileIcon from "images/fileIcon.svg";
import { useStores } from "stores";
import { DetailsModal } from "../WithdrawalRequestsList/DetailsModal";

export const ColumnShowInfoBtn = (props: any) => {
  const { companyId } = props;
  const { actionModals } = useStores();

  const showDetails = (companyId: string) =>
    actionModals.open(() => <DetailsModal companyId={companyId} />, {
      width: "700px",
      onClose: actionModals.closeAll,
      isOverlayClose: true,
    });

  return (
    <CustomButton
      onClick={() => showDetails(companyId)}
      size="small"
      tooltip="Реквизиты получателя"
      variant="text"
      {...props}
    >
      <img src={FileIcon} alt="showDetails" />
    </CustomButton>
  );
};
